<script>
    import Footer from '../landing_page/footer.svelte';
    const {title} = rpcjs.props;
    title.set('Kanoo');
    import BenifateSection from './benifate_section.svelte';
    import KanooVideoHeader from './KanooVideoHeader.svelte';
    import {
        kanoo,
        benifateSectionKanoo,
    } from './program_data.js';

    const data = [
        {
            img: '/images/kanoo/bulding.svg',
            description: 'Residency program in Silicon Valley',
            descriptionPara:
                'Qualifying founders will attend a residency program in Silicon Valley.'+
                ' Growing their business, receiving 1:1 mentorship, networking and pitching to global investors.',
            width: '5.257vw',
            left: '4.5vw',
        },
        {
            img: '/images/kanoo/btc.svg',
            description: 'Blockchain and Cryptocurrency',
            descriptionPara:
                'Blockchain and cryptocurrency are an important part of global business. '+
                'With all the information available on blockchain and cryptocurrency, it can be difficult to chart '+
                'your path to success. Let us help you on your journey. Draper University’s track'+
                ' record in blockchain is unparalleled '+
                '- from Draper’s early investments in Bitcoin, Ethereum and Coinbase through to'+
                ' Boost VCbacking Sci-Fi Startups.',
            width: '5.264vw',
            left: '4.6vw',
        },
        {
            img: '/images/kanoo/KanooInnovation.svg',
            description: 'Kanoo Innovation Hub program',
            descriptionPara:
                'Through the Kanoo Innovation Hub program, Draper University will give Caribbean entrepreneurs '+
                'the opportunity to enter the blockchain environment fully equipped to bring an idea to life;'+
                ' start your own business; or grow your existing enterprise.',
            width: '10.185vw',
            left: '2.353vw',
        },
        {
            img: '/images/kanoo/OperatingDuringUncertanity.svg',
            description: 'Launch your own Startup',
            descriptionPara:
                'You could be one of Draper University’s next alumni to launch their own startup! More than 1000 of '+
                'our alumni have raised $900M in venture funding, sold their companies '+
                'for multiple millions and have been '+
                'featured in the Forbes 30 under 30.',
            width: '6.513vw',
            left: '3.353vw',
        },
    ];

    const openDiv = [];
    let btn;
    const curriculum = [
        {
            image: '/images/kanoo/bulding.svg',
            img_width: '5vw',
            img_left: '5vw',
            heading: 'Residency program in Silicon Valley',
            width: '5.521vw',
            points: [
                {
                    bullet: 'Qualifying founders will attend a residency program in Silicon Valley. '+
                    'Growing their business, receiving 1:1 mentorship, networking and pitching to global investors.',
                },
            ],
        },
        {
            image: '/images/kanoo/btc.svg',
            heading: 'Blockchain and Cryptocurrency',
            img_width: ' 5vw',
            img_left: '5vw',
            width: '7.198vw',
            points: [
                {
                    bullet: 'Blockchain and cryptocurrency are an important part of global business. With all the '+
                    'information available on blockchain and cryptocurrency, it can be difficult to chart your path'+
                    ' to success. Let us help you on your journey. Draper University’s track record in blockchain is '+
                    'unparalleled - from Draper’s early investments in Bitcoin, Ethereum and Coinbase through to Boost '+
                    'VCbacking Sci-Fi Startups.',
                },
            ],
        },
        {
            image: '/images/kanoo/KanooInnovation.svg',
            heading: 'Kanoo Innovation Hub program',
            img_width: '3.5vw',
            img_left: '6.5vw',
            width: '4.185vw',
            points: [
                {
                    bullet: 'Through the Kanoo Innovation Hub program, Draper University will give Caribbean entrepreneurs'+
                    ' the opportunity to enter the blockchain environment'+
                    ' fully equipped to bring an idea to life; start your'+
                    ' own business; or grow your existing enterprise.',
                },
            ],
        },
        {
            image: '/images/kanoo/OperatingDuringUncertanity.svg',
            heading: 'Launch your own Startup',
            img_width: '3.5vw',
            img_left: '6.5vw',
            width: '4.185vw',
            points: [
                {
                    bullet: 'You could be one of Draper University’s next alumni to launch their own startup! More than'+
                    ' 1000 of our alumni have raised $900M in venture funding, sold their companies for multiple millions'+
                    ' and have been featured in the Forbes 30 under 30.',
                },
            ],
        },
    ];
</script>

<KanooVideoHeader
    data={kanoo}
    lineHeight="12.630vw"
    lineHeightMbl="11.111vw"
    TopMbl="97vw"
    check={false}
    colors="white"
    MargintopMbl="25vw"
    hrTop="-0.5vw"
    headingTop="-8vw"
    headingLeft="-0.063vw"
    hrWidth="72.929vw"
    wordSpace="0.3vw"
    textWidth="68.698vw"
    textWidthWbl="85.834vw"
/>
<BenifateSection data={benifateSectionKanoo} />
<div
    style="background: linear-gradient(1.05deg, rgb(0, 32, 75) 25.19%, rgb(0, 66, 155) 99.35%);
            margin-top: 5vw;
            padding: 1vw;"
>
    <div class="boxHolder">
        <div class="text_header">
            <h1>02</h1>
            <h1>Two incredible programs to start and scale your business.</h1>
        </div>
        <div class="text-headerbtn">
            <button on:click={() => (location.href = '/applyProgram')}
                >Apply</button
            >
        </div>
        <div class="boxWrraper">
            <div class="box">
                <div class="imgWrraper">
                    <img
                        src="/images/kanoo/01_Kanoo Fellowship.png"
                        alt="Kanoo Fellowship"
                        height="100%"
                        width="100%"
                    />
                </div>
                <h1>Kanoo Innovation Hub Startup Program</h1>
                <p>Develop technology, innovation and investment ecosystem</p>
                <div class="learnMore">
                    <p>Learn More</p>
                    <img
                        src="/images/kanoo/Line.svg"
                        alt="arrow"
                        width="100%"
                        height="100%"
                    />
                </div>
            </div>
            <div class="box">
                <div class="imgWrraper">
                    <img
                        src="/images/kanoo/02_Kanoo Accelerator.png"
                        alt="Accelerator"
                        height="100%"
                        width="100%"
                    />
                </div>
                <h1>Kanoo Innovation HubPre-Accelerator</h1>
                <p>
                    This focused 4-week virtual program is for highly ambitious
                    founders who are looking to scale their startup globally.
                </p>
                <div class="learnMore">
                    <p>Learn More</p>
                    <img
                        src="/images/kanoo/Line.svg"
                        alt="arrow"
                        width="100%"
                        height="100%"
                    />
                </div>
            </div>
        </div>
    </div>
</div>
<div style="width: 88.815vw;margin:5.905vw auto;padding:0 1vw;">
    <div class="circle" />
    <div class="text_header2">
        <h1>03</h1>
        <h1>Silicon Valley Residence Acceleration</h1>
    </div>
    <div
        class="desktop"
        style="border-radius:1.2vw;box-shadow: 0vw 0.265vw 2.912vw rgba(0, 32, 75, 0.2);margin-top:5vw;"
    >
        {#each data as data}
            <div class="content-holder">
                <div
                    style="display: inline-flex;align-items: center;padding:3vw;width:100%"
                >
                    <div
                        class="img-wrraper-logo"
                        style="width: 3.5vw;margin-right: 5vw;"
                    >
                        <img
                            style="width:{data.width};margin-left: {data.left};"
                            src={data.img}
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div>
                        <h1
                            class="section1list"
                            style="font-weight: 600;
                                font-size: 1.984vw;
                                color: rgba(0, 32, 75, 1);
                                margin-left: 9vw;"
                        >
                            {data.description}
                        </h1>
                        <p
                            style="font-size: 1.190vw;
                        color: rgba(0, 32, 75, 1);
                        margin-left: 9vw;
                        width:58.788vw;
                        "
                        >
                            {data.descriptionPara}
                        </p>
                    </div>
                </div>
            </div>
        {/each}
    </div>
    <div
        style="width: 91.111vw;margin:7vw auto;padding:0 1vw;position: relative;
    left: -2vw;"
        class="mobile"
    >
        <div
            style="border-radius:3vw;box-shadow: 0vw 0.265vw 2.912vw rgba(0, 32, 75, 0.2);"
        >
            {#each curriculum as data, i}
                <div class="content-holder">
                    <div
                        style="display: flex;align-items: baseline;padding:3vw;"
                    >
                        <div
                            class="img-wrraper-logo"
                            style="margin-right: 5vw;width:7vw;"
                        >
                            <img src={data.image} alt="" width="100%" />
                        </div>
                        <div>
                            <h1
                                class="section1list"
                                style="font-size: 3.889vw;width: 64vw; font-weight:600;"
                            >
                                {data.heading}
                            </h1>
                        </div>
                        <div style="">
                            <button
                                class="view-all-btn "
                                on:click={() => {
                                    if (openDiv[i].style.display === 'none') {
                                        openDiv[i].style.display = 'block';
                                        btn.style.transform = 'rotate(180deg)';
                                    } else {
                                        openDiv[i].style.display = 'none';
                                        btn.style.transform = 'rotate(0deg)';
                                    }
                                }}
                            >
                                <img
                                    bind:this={btn}
                                    src="/images/Hero_section/drop_down.svg"
                                    alt=""
                                    width="100%"
                                />
                            </button>
                        </div>
                    </div>

                    <div
                        class="open_div"
                        style="width: 75vw;margin: 3vw auto 2vw auto;"
                        bind:this={openDiv[i]}
                    >
                        <div style="">
                            <ul
                                class="points"
                                style="
                                margin-top:2vw;
                                width: 70vw;
                                margin-left: 4vw;padding-bottom: 2vw;"
                            >
                                {#each data.points as bulletMbl}
                                    <li>
                                        <p
                                            style="font-size:3.056vw;line-height:3.068vw;"
                                        >
                                            {bulletMbl.bullet}
                                        </p>
                                    </li>
                                {/each}
                            </ul>
                        </div>
                    </div>
                </div>
            {/each}
        </div>
    </div>
</div>
<div class="kanoimageWrraper">
    <img
        src="/images/kanoo/KanooInnovationHub.png"
        alt="kanoo"
        width="100%"
        height="100%"
    />
</div>
<div class="headingLastWrraper">
    <div>
        <h1 class="headinglast">Building or scaling innovative projects?</h1>
    </div>
    <div>
        <button on:click={() => (location.href = '/applyProgram')}>Apply</button
        >
    </div>
</div>
<Footer />

<style>
    .content-holder:nth-child(odd) {
        background-color: rgba(226, 242, 255, 1);
    }
    .content-holder:nth-child(1) {
        border-top-left-radius: 3vw;
        border-top-right-radius: 3vw;
    }
    .view-all-btn {
        border: none;
        background-color: transparent;
        width: 3.2vw;
    }
    ul {
        padding: 0;
        margin: 0;
        margin-top: 1.323vw;
    }
    .points li::marker {
        color: #7cc1ff;
        font-size: 4.056vw;
    }
    .open_div {
        display: none;
    }
    .mobile {
        display: none;
    }
    .boxWrraper {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-around;
    }
    .box {
        position: relative;
        margin-top: 5vw;
        box-sizing: border-box;
        padding: 2vw;
        width: 38.161vw;
        height: 28.902vw;
        border-radius: 1.779vw;
    }
    .box::after {
        content: "";
        top: 1.5vw;
        left: 2vw;
        position: absolute;
        width: 90%;
        border-bottom: 0.267vw solid #f7e05f;
    }
    .box:nth-child(1) {
        background-color: #36a1bf;
    }
    .box:nth-child(2) {
        background-color: #2c71ce;
    }
    .imgWrraper {
        width: 8.135vw;
        height: 8.135vw;
        margin: auto;
    }
    .box h1 {
        font-family: "Inter";
        font-style: normal;
        font-weight: 600;
        font-size: 1.957vw;
        line-height: 2.646vw;
        text-align: center;
        color: #ffffff;
        width: 60%;
        margin: auto;
    }
    .box p {
        font-family: "Inter";
        font-style: normal;
        font-weight: 400;
        font-size: 1.653vw;
        line-height: 2.315vw;
        text-align: center;
        color: #ffffff;
        width: 90%;
        margin-top: 1vw !important;
        margin: auto;
    }
    .learnMore {
        text-align: center;
        position: absolute;
        bottom: 1vw;
        left: 16vw;
    }
    .learnMore p {
        font-family: "Inter";
        font-style: normal;
        font-weight: 500;
        font-size: 0.926vw;
        line-height: 1.124vw;
        color: #ffffff;
        width: fit-content;
    }
    .learnMore img {
        width: 5.489vw;
    }
    .content-holder:nth-child(odd) {
        background-color: rgba(226, 242, 255, 1);
    }
    .content-holder:nth-child(even) {
        background-color: white;
    }
    .content-holder:nth-child(1) {
        border-top-left-radius: 1vw;
        border-top-right-radius: 1vw;
    }
    .content-holder:nth-last-child(1) {
        border-bottom-left-radius: 1vw;
        border-bottom-right-radius: 1vw;
    }
    .circle {
        height: 24.802vw;
        width: 24.802vw;
        border-radius: 50%;
        position: absolute;
        left: -14.286vw;
        background-color: rgba(60, 136, 195, 0.33);
        justify-content: center;
        z-index: -1;
        opacity: 40%;
    }
    .circle::after {
        content: "";
        top: 10.78vw;
        height: inherit;
        width: inherit;
        border-radius: 50%;
        position: absolute;
        left: 0;
        background-color: inherit;
    }
    .circle::before {
        content: "";
        top: 19.78vw;
        height: inherit;
        width: inherit;
        border-radius: 50%;
        position: absolute;
        left: 0;
        background-color: inherit;
    }
    .headinglast {
        font-family: "Inter";
        font-style: normal;
        font-weight: 700;
        font-size: 2.497vw;
        line-height: 3.042vw;
        color: #00204b;
        width: 35.78vw;
    }
    .text_header {
        display: flex;
        align-items: center;
    }
    .text_header h1:nth-child(1) {
        color: white;
        font-size: 1.191vw;
        margin-right: 5vw;
        opacity: 0.7;
    }
    .text_header h1:nth-child(2) {
        color: white;
        font-size: 2.068vw;
        text-transform: uppercase;
    }
    .text-headerbtn {
        text-align: center;
        margin-top: 3vw;
    }
    button {
        width: 15.619vw;
        height: 3.905vw;
        border-radius: 1.985vw;
        border: none;
        background-color: #f7e05f;
        font-size: 1.191vw;
    }
    .boxHolder {
        width: 88.815vw;
        margin: 5vw auto;
        padding: 0 1vw;
        position: relative;
    }
    .text_header2 {
        display: flex;
        align-items: center;
    }
    .text_header2 h1:nth-child(1) {
        color: rgb(0, 0, 0);
        font-size: 1.191vw;
        margin-right: 5vw;
        opacity: 0.7;
    }
    .text_header2 h1:nth-child(2) {
        color: rgb(0, 0, 0);
        font-size: 2.068vw;
        text-transform: uppercase;
    }
    .text-headerbtn {
        text-align: center;
        margin-top: 3vw;
    }
    .text-headerbtn button {
        width: 15.619vw;
        height: 3.905vw;
        border-radius: 1.985vw;
        border: none;
        background-color: #f7e05f;
        font-size: 1.191vw;
    }
    .headingLastWrraper {
        display: flex;
        align-items: center;
        background-color: #00fffe;
        height: 14.815vw;
        justify-content: space-around;
    }
    @media screen and (max-width: 1024px) {
        .boxWrraper {
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-around;
            flex-direction: column;
        }
        .box {
            position: relative;
            margin-top: 5vw;
            box-sizing: border-box;
            padding: 2vw;
            width: 87.612vw;
            height: 66.355vw;
            border-radius: 1.779vw;
        }
        .imgWrraper {
            width: 18.678vw;
            height: 18.678vw;
            margin: auto;
        }
        .box h1 {
            font-size: 4.493vw;
            line-height: 6vw;
            color: #ffffff;
            width: 60%;
            margin: auto;
        }
        .box p {
            font-family: "Inter";
            font-style: normal;
            font-weight: 400;
            font-size: 3.797vw;
            line-height: 6vw;
            text-align: center;
            color: #ffffff;
            width: 90%;
            margin: auto;
        }
        .learnMore {
            text-align: center;
            position: absolute;
            bottom: 1vw;
            left: 16vw;
            width: 55vw;
        }
        .learnMore p {
            font-family: "Inter";
            font-style: normal;
            font-weight: 500;
            font-size: 2.126vw;
            line-height: 1.124vw;
            color: #ffffff;
            width: fit-content;
        }
        .learnMore img {
            width: 12.575vw;
        }
        .text_header {
            display: flex;
            align-items: center;
            flex-direction: column;
        }
        .text_header h1:nth-child(1) {
            color: white;
            font-size: 1.191vw;
            margin-right: 5vw;
            opacity: 0.7;
            display: none;
        }
        .text_header h1:nth-child(2) {
            color: white;
            font-size: 5.556vw;
            text-transform: uppercase;
            width: 85%;
            margin: auto;
        }
        .text-headerbtn button {
            width: 27.103vw;
            height: 10.514vw;
            border-radius: 20vw;
            border: none;
            background-color: #f7e05f;
            font-size: 3.612vw;
            position: absolute;
            bottom: -18vw;
            left: 32vw;
        }
        .boxHolder {
            margin: 7vw auto 25vw;
        }
        .text_header2 h1:nth-child(2) {
            color: rgb(0, 0, 0);
            font-size: 5.556vw;
            text-transform: uppercase;
            width: 90%;
            text-align: justify;
            font-weight: 600;
        }
        button {
            width: 27.103vw;
            height: 10.514vw;
            border-radius: 20vw;
            border: none;
            background-color: #f7e05f;
            font-size: 3.612vw;
        }
        .headingLastWrraper {
            height: fit-content;
            padding: 5vw 0 10vw;
            flex-direction: column;
        }
        .headinglast {
            font-weight: 700;
            font-size: 8.822vw;
            line-height: 10vw;
            width: 75.78vw;
            text-align: center;
            margin: 6vw;
        }
        .mobile {
            display: block;
        }
        .desktop {
            display: none;
        }
    }
</style>
